import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface firstState {
  token: string | null;
  userId: string | null;
  userName: string | null;
  roles: string[] | null;
}

const getStoredRoles = (): string[] | null => {
  const roles = localStorage.getItem("roles");
  try {
    return roles ? JSON.parse(roles) : null;
  } catch {
    return null;
  }
};

const initialState: firstState = {
  token: localStorage.getItem("token"),
  userId: localStorage.getItem("userId"),
  userName: localStorage.getItem("userName"),
  roles: getStoredRoles(),
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    login(
      state: firstState,
      action: PayloadAction<{
        token: string;
        id: string;
        userName: string;
        roles: string[];
      }>,
    ) {
      state.token = action.payload.token;
      state.userId = action.payload.id;
      state.userName = action.payload.userName;
      state.roles = action.payload.roles;
    },
    logout(state: firstState) {
      state.token = null;
      state.userId = null;
      state.userName = null;
      state.roles = null;
    },
  },
});

export const authActions = authSlice.actions;

export default authSlice;
